import React, { useRef } from 'react';

import Select from '@atlaskit/select';

import { type TemplateOption } from '../../../../../../controllers/edit/types';

import { TimingMenuList } from './timing-menu-list';
import { extraTimingSelectProps } from './timing-menu-list/constants';
import { type TemplateSelectProps } from './types';

const TemplateSelect: React.FC<TemplateSelectProps> = ({ onCustomize, ...selectProps }) => {
	const selectRef = useRef<any | null>(null);

	const onCustom = () => {
		selectRef.current?.blur();
		onCustomize();
	};

	return (
		<Select<TemplateOption, false>
			{...selectProps}
			{...extraTimingSelectProps}
			ref={selectRef}
			components={{
				MenuList: (props) => <TimingMenuList {...props} onCustom={onCustom} />,
			}}
		/>
	);
};

export { TemplateSelect };
